<template>
  <CRow>
    <CModal
        :title="
        submitType === 'Update'
          ? $lang.notification.crud.edit
          : $lang.notification.crud.create
      "
        size="lg"
        :show.sync="largeModal"
        :no-close-on-backdrop="true"
        color="primary"
    >
      <CAlert color="danger" closeButton :show.sync="dismissCountDown" fade>{{
          err_msg
        }}
      </CAlert>
      <CForm novalidate @submit.prevent="onSubmit">
        <CCardBody>
          <div class="form-group" :class="{ 'form-group--error': '' }">
            <label class="form__label"
            >{{ $lang.notification.form.type }}
              <required_span/>
            </label>
            <v-select
                :options="typeList"
                v-model="notification.type"
                :disabled="submitType === 'Update'"
            >
            </v-select>
            <small
                class="error"
                v-if="
                $v.notification.type.$error &&
                !$v.notification.type.required
              "
            >
              {{ $lang.notification.validation.required.type }}
            </small>
          </div>
          <div
              class="form-group"
              :class="{
              'form-group--error': $v.notification.notificationType.$error,
            }"
          >
            <label class="form__label">
              <span id="formTitle">{{
                  $lang.notification.form.notificationType
                }}</span>
              <required_span/>
            </label>
            <input
                :maxlength="maxlength.notificationType"
                :disabled="submitType === 'Update'"
                :placeholder="$lang.notification.form.notificationType"
                class="form-control"
                v-model="notification.notificationType"
            />
            <small
                class="error"
                v-if="
                $v.notification.notificationType.$error &&
                !$v.notification.notificationType.required
              "
            >
              {{ $lang.notification.validation.required.notificationType }}
            </small>
          </div>

          <div
              class="form-group"
              :class="{ 'form-group--error': $v.notification.title.$error }"
          >
            <label class="form__label">
              <span id="formTitle">{{ $lang.notification.form.title }}</span>
              <required_span/>
            </label>
            <input
                :maxlength="maxlength.title"
                :placeholder="$lang.notification.form.title"
                class="form-control"
                v-model="notification.title"
            />
            <small
                class="error"
                v-if="
                $v.notification.title.$error && !$v.notification.title.required
              "
            >
              {{ $lang.notification.validation.required.title }}
            </small>
          </div>

          <div
              class="form-group"
              :class="{ 'form-group--error': $v.notification.name.$error }"
          >
            <label class="form__label">
              <span id="formTitle">{{ $lang.notification.form.name }}</span>
              <required_span/>
            </label>
            <input
                :maxlength="maxlength.name"
                :placeholder="$lang.notification.form.name"
                class="form-control"
                v-model="notification.name"
            />
            <small
                class="error"
                v-if="
                $v.notification.name.$error && !$v.notification.name.required
              "
            >
              {{ $lang.notification.validation.required.name }}
            </small>
          </div>

          <div
              class="form-group"
              :class="{ 'form-group--error': $v.notification.message.$error }"
          >
            <label class="form__label">
              <span id="formTitle">{{ $lang.notification.form.message }}</span>
              <required_span/>
            </label>
            <textarea
                :maxlength="maxlength.message"
                :placeholder="$lang.notification.form.message"
                class="form-control"
                v-model="notification.message"
            />
            <small
                class="error"
                v-if="
                $v.notification.message.$error &&
                !$v.notification.message.required
              "
            >
              {{ $lang.notification.validation.required.message }}
            </small>
          </div>
        </CCardBody>
        <CCardFooter>
          <CButton
              type="submit"
              size="sm"
              color="primary"
              :disabled="submitted"
          >
            <CIcon name="cil-check-circle"/>
            {{ $lang.buttons.general.crud.submit }}
          </CButton>
        </CCardFooter>
      </CForm>
      <template #footer style="display: none">
        <CButton @click="darkModal = false" color="danger" style="display: none"
        >Discard
        </CButton
        >
        <CButton
            @click="darkModal = false"
            color="success"
            style="display: none"
        >Accept
        </CButton
        >
      </template>
    </CModal>
    <CCol col="12">
      <CCard>
        <CCardHeader>
          <div class="row">
            <CCol sm="6" class="align-self-center">
              <strong>{{ $lang.notification.title }}</strong>
            </CCol>
            <CCol sm="6" class="align-self-center">
              <div class="text-sm-right mt-3 mt-sm-0">
                <CButton
                    color="primary"
                    v-on:click="createTableRow"
                    v-if="checkPermission('create-notification')"
                    style="margin-right: 10px"
                >
                  {{ $lang.buttons.general.crud.create }}
                </CButton>
                <CButtonGroup class="file-export">
                  <CButton color="secondary" disabled>
                    {{ $lang.buttons.export.title }}
                  </CButton>
                  <CButton
                      color="danger"
                      v-c-tooltip="$lang.buttons.export.pdf"
                      v-on:click="exports(self, 'pdf', module, 'Notifications')"
                  >
                    <i class="fas fa-file-pdf"></i>
                  </CButton>
                  <VueJsonToCsv
                      class="btn btn-success"
                      v-c-tooltip="$lang.buttons.export.excel"
                      :json-data="json_data"
                      :labels="json_label"
                      :csv-title="json_title"
                  >
                    <i class="fas fa-file-excel"></i>
                  </VueJsonToCsv>
                </CButtonGroup>
              </div>
            </CCol>
          </div>
        </CCardHeader>
        <CCardBody>
          <CAlert
              color="success"
              closeButton
              :show.sync="dismissCountDownS"
              fade
          >{{ alertMessage }}
          </CAlert
          >
          <v-server-table
              :columns="columns"
              url="/notifications/list"
              :options="options"
              ref="myTable"
              @loaded="exports(self, 'Excel', module, 'Notifications')"
          >
            <template #notificationType="data">
              <span :title="data.row.notificationType">{{
                  trimfunction(data.row.notificationType, 50)
                }}</span>
            </template>
            <template #name="data">
              <span :title="data.row.name">{{
                  trimfunction(data.row.name, 50)
                }}</span>
            </template>
            <template #title="data">
              <span :title="data.row.title">{{
                  trimfunction(data.row.title, 50)
                }}</span>
            </template>
            <template #actions="data">
              <CButton
                  color="success"
                  v-c-tooltip="$lang.buttons.general.crud.edit"
                  v-on:click="editTableRow(data.row.id)"
                  v-if="checkPermission('edit-notification')"
              >
                <i class="fas fa-pencil-alt"></i>
              </CButton>
              <CButton
                  color="danger"
                  v-c-tooltip="$lang.buttons.general.crud.delete"
                  v-on:click="deletePopup(data.row.id)"
                  v-if="checkPermission('delete-notification')"
              >
                <i class="fas fa-trash"></i>
              </CButton>
            </template>
          </v-server-table>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import Vue from "vue";
import VueForm from "vue-form";
import {notification} from "/src/store/url.js";
import {Mixin} from "/src/mixins/index.js";
import options from "/src/validations/validations.js";
import {ServerTable} from "vue-tables-2";
import VueSweetalert2 from "vue-sweetalert2";
import {required} from "vuelidate/lib/validators";
import required_span from "../../components/layouts/general/required-span";
import VueJsonToCsv from "vue-json-to-csv";
import {Maxlength} from "../../store/maxlength";

Vue.use(VueSweetalert2);
Vue.use(ServerTable, {}, false);
Vue.use(VueForm, options);

export default {
  name: "NotificationItem",
  mixins: [Mixin],
  components: {
    required_span,
    VueJsonToCsv,
  },
  data() {
    return {
      submitted: false,
      json_data: [],
      json_label: {},
      json_title: "",
      err_msg: "",
      largeModal: false,
      submitType: "",
      alertMessage: "test",
      showAlert: false,
      dismissCountDown: 0,
      dismissCountDownS: 0,
      self: this,
      msg: "",
      typeList: [],
      activePage: 1,
      module: notification,
      notification: {
        name: "",
        type: "",
        notificationType: "",
        title: "",
        message: "",
      },
      maxlength: {
        name: Maxlength.notification.name,
        notificationType: Maxlength.notification.notificationType,
        title: Maxlength.notification.title,
        message: Maxlength.notification.message,
      },
      columns: ["type", "notificationType", "name", "title", "actions"],
      data: [],
      options: {
        headings: {
          type: this.$lang.notification.table.type,
          notificationType: this.$lang.notification.table.notificationType,
          name: this.$lang.notification.table.name,
          title: this.$lang.notification.table.title,
          actions: this.$lang.common.general.actions,
        },
        editableColumns: ["title"],
        sortable: ["title"],
        filterable: ["title"],
      },
    };
  },
  validations: {
    notification: {
      type: {
        required,
      },
      title: {
        required,
      },
      name: {
        required,
      },
      message: {
        required,
      },
      notificationType: {
        required,
      },
    },
  },
  mounted() {
    let self = this;
    self.typeList.push(
        {value: "PROFILE", label: "PROFILE"},
        {value: "POST", label: "POST"},
        {value: "PROJECT", label: "PROJECT"},
        {value: "BT", label: "BUSINESS TRAVELLER"},
        {value: "RESOURCE", label: "RESOURCE"}
    );

    self.dismissCountDown = 0;
    self.dismissCountDownS = 0;
    if (localStorage.getItem("showAlert") !== "") {
      this.setAlert(true);
    }
    this.setAlert(false);
    localStorage.setItem("showAlert", "");
  },
  watch: {
    $route: {
      immediate: true,
      handler(route) {
        if (route.query && route.query.page) {
          this.activePage = Number(route.query.page);
        }
      },
    },
  },
  methods: {
    createTableRow() {
      let self = this;
      self.submitType = "";
      self.$v.$reset();
      self.notification.type = "";
      self.notification.notificationType = "";
      self.notification.title = "";
      self.notification.name = "";
      self.notification.message = "";
      self.largeModal = true;
    },
    editTableRow(item) {
      let self = this;
      self.$v.$reset();
      self.submitType = "Update";
      const id = item;
      self.editId = item;
      axios
          .get(this.viewUrlApi(this.module, id), self.model)
          .then(function (response) {
            if (response) {
              const responseData = response.data.data;
              self.notification.title = responseData.title;
              self.notification.message = responseData.message;
              self.notification.name = responseData.name;
              self.notification.notificationType = responseData.notificationType;
              self.notification.type = {
                value: responseData.type,
                label: responseData.type,
              };
            } else {
              self.data = [];
            }
          });
      self.largeModal = true;
    },
    setAlert(value) {
      this.showAlert = value;
    },
    deletePopup(item) {
      this.$swal({
        title: this.$lang.common.delete_swal.are_you,
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#e55353",
        confirmButtonText: this.$lang.common.delete_swal.yes_delete,
        cancelButtonText: this.$lang.common.delete_swal.cancel,
      }).then((result) => {
        if (result.value) {
          let self = this;
          axios
              .delete(this.deleteUrlWeb(this.module, item), self)
              .then(function (response) {
                if (response.status === 200) {
                  self.$refs.myTable.refresh();
                  self.alertMessage = response.data.message;
                  self.dismissCountDownS = 10;
                }
              }).catch(function (error) {
            let data;
            if (error.response.data.error) {
              data = error.response.data.error.toString();
            } else {
              data = error.response.data.message;
            }
            self.alertMessage = data;
            self.messageColor = "danger";
            self.dismissCountDownS = 10;
          });
        }
      });
    },
    applyFilter() {
      let self = this;
      this.$refs.myTable.customQueries  = {
        id:
            self.notification.industry !== null &&
            Object.keys(self.notification.industry).length > 0 &&
            self.notification.industry.value > 0
                ? self.notification.industry.value
                : "0",
        industry_id:
            self.notification.subIndustry !== null &&
            Object.keys(self.notification.subIndustry).length > 0 &&
            self.notification.subIndustry.value > 0
                ? self.notification.subIndustry.value
                : "0",
        applyFilter: "true",
      };
      this.$refs.myTable.refresh();
    },
    resetFilter() {
      this.state.countryName = {};
      this.$refs.myTable.customQueries = {};
      this.$refs.myTable.refresh();
    },
    onSubmit() {
      let self = this;
      this.$v.notification.$touch();
      if (this.$v.notification.$invalid) {
        self.submitted = false; //Enable Button
        this.submitStatus = "ERROR";
      } else {
        self.submitted = true; //Disable Button
        this.submitStatus = "PENDING";
        if (this.submitType === "Update") {
          setTimeout(() => {
            let self = this;
            const postData = {
              title: self.notification.title,
              name: self.notification.name,
              message: self.notification.message,
            };
            axios
                .post(this.updateUrlweb(this.module, self.editId), postData)
                .then(function (response) {
                  self.submitted = false; //Enable Button
                  if (response.data.code === 200) {
                    self.largeModal = false;
                    self.$refs.myTable.refresh();
                    self.alertMessage = response.data.message;
                    self.dismissCountDownS = 10;
                  } else {
                    self.err_msg = response.data.message;
                    self.dismissCountDown = 10;
                  }
                }).catch(function (error) {
              let data;
              if (error.response.data.error) {
                data = error.response.data.error.toString();
              } else {
                data = error.response.data.message;
              }
              self.err_msg = data;
              self.dismissCountDown = 10;
              self.submitted = false; //Enable Button
            });
          }, 500);
        } else {
          setTimeout(() => {
            let self = this;
            let type, notificationType;
            if (self.notification.type !== "") {
              type = self.notification.type.value;
            } else {
              type = "";
            }
            if (self.notification.notificationType !== "") {
              notificationType = self.notification.notificationType;
            } else {
              notificationType = "";
            }
            const postData = {
              title: self.notification.title,
              name: self.notification.name,
              notificationType: notificationType,
              type: type,
              message: self.notification.message,
            };
            axios
                .post(this.createUrlWeb(this.module), postData)
                .then(function (response) {
                  self.submitted = false; //Enable Button
                  if (response.data.code === 200) {
                    self.alertMessage = response.data.message;
                    self.dismissCountDownS = 10;
                    self.largeModal = false;
                    self.$refs.myTable.refresh();
                  } else {
                    self.err_msg = response.data.message;
                    self.dismissCountDown = 10;
                  }
                }).catch(function (error) {
              let data;
              if (error.response.data.error) {
                data = error.response.data.error.toString();
              } else {
                data = error.response.data.message;
              }
              self.err_msg = data;
              self.dismissCountDown = 10;
              self.submitted = false; //Enable Button
            });
          }, 500);
        }
      }
    },
  },
};
</script>
